import { render, staticRenderFns } from "./RobotList.vue?vue&type=template&id=58501e40&"
import script from "./RobotList.vue?vue&type=script&lang=js&"
export * from "./RobotList.vue?vue&type=script&lang=js&"
import style0 from "./RobotList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports